import { Box } from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "./styles";
import FalconHead from "./FalconHead";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import Loader from "router/components/Loader";
import FalconBody from "./FalconBody";

interface PropsType {}

const FalconPage: FC<PropsType> = () => {
  const classes = useStyles();
  const { loadingData } = useTypeSelectors((state) => state.falconTable);

  return (
    <Box className={classes.root}>
      <Loader isLoading={loadingData} />
      <FalconHead />
      <FalconBody/>
    </Box>
  );
};

export default FalconPage;
